import classNames from 'classnames';
import { IconProps } from '.';

export const AddNoteIcon = ({ className, color }: IconProps) => {
  const fill = color ?? 'var(--color-primary)';

  return (
    <svg
      className={classNames(className)}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.15'
        d='M10.8 18C14.7764 18 18 14.7765 18 10.8V6.08754C18 6.81913 17.8296 7.54067 17.5024 8.19502C16.7042 9.79152 15.0724 10.8 13.2875 10.8H10.8V16.2L7.19995 18H10.8Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.8 10.8H13.5C14.9912 10.8 16.2 9.59117 16.2 8.1V4.5C16.2 3.00883 14.9912 1.8 13.5 1.8H4.5C3.00883 1.8 1.8 3.00883 1.8 4.5V13.5C1.8 14.9912 3.00883 16.2 4.5 16.2H8.1C9.59117 16.2 10.8 14.9912 10.8 13.5V10.8ZM12.6 13.5V12.6H13.5C15.9853 12.6 18 10.5853 18 8.1V4.5C18 2.01472 15.9853 0 13.5 0H4.5C2.01472 0 0 2.01472 0 4.5V13.5C0 15.9853 2.01472 18 4.5 18H8.1C10.5853 18 12.6 15.9853 12.6 13.5Z'
        fill={fill}
      />
      <path
        opacity='0.72'
        d='M7.20596 3.6001V5.39424H9.0001V7.19424H7.20596V9.0001H5.40596V7.19424H3.6001V5.39424H5.40596V3.6001H7.20596Z'
        fill={fill}
      />
    </svg>
  );
};
